import React from 'react';

// Импортируем модульные стили для этой секции
import styles from './BenefitsSection.module.css';

// Импортируем иконки для каждого преимущества. 
import { ReactComponent as PerformanceIcon } from '../../assets/icons/performance.svg';
import { ReactComponent as ReliabilityIcon } from '../../assets/icons/reliability.svg';
import { ReactComponent as QuickStartIcon } from '../../assets/icons/quick-start.svg';
import { ReactComponent as DeliveryIcon } from '../../assets/icons/delivery.svg';

// Создаем массив с данными для наших преимуществ.
const benefitsData = [
  {
    Icon: PerformanceIcon,
    title: 'Высокая производительность',
    description: 'Подберем оптимальную модель БРУ мощностью от 10 до 200 м³/ч под любые задачи вашего проекта.',
  },
  {
    Icon: ReliabilityIcon,
    title: 'Гарантия и надежность',
    description: 'Используем только сертифицированные компоненты и предоставляем официальную гарантию на все оборудование.',
  },
  {
    Icon: QuickStartIcon,
    title: 'Быстрый запуск',
    description: 'Профессиональный монтаж и пуско-наладочные работы на вашем объекте в срок от 10 до 15 дней.',
  },
  {
    Icon: DeliveryIcon,
    title: 'Доставка по СНГ',
    description: 'Собственный отдел логистики организует быструю и безопасную доставку в любую точку Казахстана и СНГ.',
  },
];


const BenefitsSection = () => {
  return (
    <section id="benefits" className={styles.benefitsSection}>
      <div className="container">
        {/* Заголовок секции */}
        <h2 className={styles.sectionTitle}>
          Почему выбирают нас?
        </h2>
        <p className={styles.sectionSubtitle}>
          Мы предлагаем не просто оборудование, а комплексные решения для вашего бизнеса.
        </p>

        {/* Сетка для отображения преимуществ */}
        <div className={styles.benefitsGrid}>
          {benefitsData.map((benefit, index) => (
            <div key={index} className={styles.benefitCard}>
              <div className={styles.iconWrapper}>
                <benefit.Icon className={styles.icon} />
              </div>
              <h3 className={styles.cardTitle}>{benefit.title}</h3>
              <p className={styles.cardDescription}>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BenefitsSection;